import ThemeOne from './theme.json';

const typography = {
  h1: {
    fontFamily: ThemeOne.h1.fontFamily,
    fontWeight: ThemeOne.h1.fontWeight,
    fontSize: ThemeOne.h1.fontSize,
    fontStyle: ThemeOne.h1.fontStyle,
    textTransform: ThemeOne.h1.textTransform as
      | "none"
      | "capitalize"
      | "uppercase"
      | "lowercase",
    color: ThemeOne.fontColor,
  },
  h2: {
    fontFamily: ThemeOne.h2.fontFamily,
    fontWeight: ThemeOne.h2.fontWeight,
    fontSize: ThemeOne.h2.fontSize,
    fontStyle: ThemeOne.h2.fontStyle,
    color: ThemeOne.fontColor,
  },
  h3: {
    fontFamily: ThemeOne.h3.fontFamily,
    fontWeight: ThemeOne.h3.fontWeight,
    fontSize: ThemeOne.h3.fontSize,
    fontStyle: ThemeOne.h3.fontStyle,
    textTransform: ThemeOne.h3.textTransform as
      | "none"
      | "capitalize"
      | "uppercase"
      | "lowercase",
    color: ThemeOne.fontColor,
    letterSpacing: '2px',
  },
  h4: {
    fontFamily: ThemeOne.h4.fontFamily,
    fontWeight: ThemeOne.h4.fontWeight,
    fontSize: ThemeOne.h4.fontSize,
    fontStyle: ThemeOne.h4.fontStyle,
    color: ThemeOne.fontColor,
  },
  h5: {
    fontFamily: ThemeOne.h5.fontFamily,
    fontWeight: ThemeOne.h5.fontWeight,
    fontSize: ThemeOne.h5.fontSize,
    fontStyle: ThemeOne.h5.fontStyle,
    color: ThemeOne.fontColor,
    textTransform: ThemeOne.h5.textTransform as
      | "none"
      | "capitalize"
      | "uppercase"
      | "lowercase",
  },
  h6: {
    fontFamily: ThemeOne.h6.fontFamily,
    fontWeight: ThemeOne.h6.fontWeight,
    fontSize: ThemeOne.h6.fontSize,
    fontStyle: ThemeOne.h6.fontStyle,
    color: ThemeOne.fontColor,
  },
  subtitle1: {
    fontFamily: ThemeOne.subtitle1.fontFamily,
    fontWeight: ThemeOne.subtitle1.fontWeight,
    fontSize: ThemeOne.subtitle1.fontSize,
    fontStyle: ThemeOne.subtitle1.fontStyle,
  },
  subtitle2: {
    fontFamily: ThemeOne.subtitle2.fontFamily,
    fontWeight: ThemeOne.subtitle2.fontWeight,
    fontSize: ThemeOne.subtitle2.fontSize,
    fontStyle: ThemeOne.subtitle2.fontStyle,
    color: ThemeOne.fontColor,
  },
  body1: {
    fontFamily: ThemeOne.body1.fontFamily,
    fontWeight: ThemeOne.body1.fontWeight,
    fontSize: ThemeOne.body1.fontSize,
    fontStyle: ThemeOne.body1.fontStyle,
    color: ThemeOne.fontColor,
  },
  body2: {
    fontFamily: ThemeOne.body2.fontFamily,
    fontWeight: ThemeOne.body2.fontWeight,
    fontSize: ThemeOne.body2.fontSize,
    fontStyle: ThemeOne.body2.fontStyle,
    color: ThemeOne.fontColor,
  },

  button: {
    fontFamily: ThemeOne.button.fontFamily,
    fontWeight: ThemeOne.button.fontWeight,
    fontSize: ThemeOne.button.fontSize,
    fontStyle: ThemeOne.button.fontStyle,
    textTransform: ThemeOne.button.textTransform as
      | "none"
      | "capitalize"
      | "uppercase"
      | "lowercase",
  },
  caption: {
    fontFamily: ThemeOne.caption.fontFamily,
    fontWeight: ThemeOne.caption.fontWeight,
    fontSize: ThemeOne.caption.fontSize,
    // textTransform: ThemeOne.caption.textTransform,
  },
  overline: {
    fontFamily: ThemeOne.overline.fontFamily,
    fontWeight: ThemeOne.overline.fontWeight,
    fontSize: ThemeOne.overline.fontSize,
  },
};

export default typography;
